module.exports = __webpack_public_path__ + "static/media/visa-icon-white-61x31.4b0df312.svg";